import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  LOGIN_USER,
  SIGNUP_USER,
  CHECK_USER,
  SIGNIN_USER,
  REGISTER_USER,
  LOGOUT_USER,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
} from '../actions';
import {
  loginUserSuccess,
  loginUserError,
  signupUserSuccess,
  signupUserError,
  checkUserSuccess,
  checkUserError,
  signinUserSuccess,
  signinUserError,
  registerUserSuccess,
  registerUserError,
  forgotPasswordSuccess,
  forgotPasswordError,
  resetPasswordSuccess,
  resetPasswordError,
} from './actions';
import { maintenanceMode } from '../../constants/defaultValues';
import queryString from 'query-string'; // import the queryString class
import moment from 'moment';

//* this function encode email address (@ is not admitted on backend side)
function getBody(jsondata) {
  var body = [];
  for (var key in jsondata) {
    var encKey = encodeURIComponent(key);
    var encVal = encodeURIComponent(jsondata[key]);
    body.push(encKey + '=' + encVal);
  }
  return body.join('&');
}

//* LOGIN User // -----------------------------------------------------

const loginWithEmailPasswordAsync = async (username, password) =>
  await fetch(`/mick/doctors/login`, {
    method: 'post',
    credentials: 'same-origin', // request the cookie from server
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded', //because we are sending a body with a form
    },
    body: getBody({ username, password }), //make sure to serialize your JSON body
  }).then((response) => {
    //console.error(response);
    if (response.ok) {
      return response;
    } else if (response.status === 502) {
      return 'The server is not available at the moment. Please try again later.';
    } else {
      return response.text();
    }
  });

const getUserDataAsync = async (username) =>
  await fetch(`/mick/doctors/${username}/info `, {
    method: 'get',
    credentials: 'include', // add the cookie to the request
    headers: {
      'Content-Type': 'application/json', //because we are requesting data in JSON type
    },
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      return data;
    });

function* loginWithEmailPassword({ payload }) {
  const { username, password } = payload.user;
  const { history, originURL } = payload;

  try {
    const loginUser = yield call(
      loginWithEmailPasswordAsync,
      username,
      password
    );

    if (loginUser.ok) {
      const userData = yield call(getUserDataAsync, username);

      let validationDateMoment = userData[0].validationDate
        ? moment(userData[0].validationDate, 'YYYY/MM/DD')
        : '';

      let accessLimitMoment = moment(userData[0].licence.access, 'YYYY/MM/DD');

      localStorage.setItem('user_id', userData[0]._id);
      localStorage.setItem('username', userData[0].username);
      localStorage.setItem('adminUsername', userData[0].adminUsername);

      userData[0].validationDate &&
        localStorage.setItem(
          'validation',
          validationDateMoment.format('DD/MM/YYYY').toString()
        );
      localStorage.setItem(
        'accessLimit',
        accessLimitMoment.format('DD/MM/YYYY').toString()
      );
      localStorage.setItem('trial', false);
      localStorage.setItem('access', false);
      localStorage.setItem('sub', '');

      // // Check if there is the validationDate key otherwise leave trial (for old users)
      // if (userData[0].validationDate) {

      // alert(accessLimitMoment.format("DD/MM/YYYY"));
      // alert(accessLimitMoment);
      // alert(moment().diff(accessLimitMoment, "days"));

      //! GRANTING ACCESS CHECK
      //* Check if the account is in trial period (less then 30 days) [trial for new users]

      var now = moment();
      var restTrialDays = now.diff(
        moment(accessLimitMoment, 'DD/MM/YYYY'),
        'days'
      );

      if (restTrialDays < 0) {
        restTrialDays = Math.abs(restTrialDays);
      } else {
        restTrialDays = 0;
      }

      if (
        (userData[0].licence.type === null ||
          userData[0].licence.type === '') &&
        restTrialDays > 0
      ) {
        // alert("ACCESS type: TRIAL + ACCESS");
        localStorage.setItem('trial', true);
        localStorage.setItem('access', true);
      }

      // Check if licence.access key property is set in the future but there is no stripe subscription yet [trial for existing users]
      // else if (
      //   userData[0].licence.access !== null &&
      //   moment(userData[0].licence.access, "DD/MM/YYYY").isAfter(moment()) &&
      //   userData[0].licence.type === null
      // ) {
      //   console.log("LEVEL 2");
      //   //localStorage.setItem("trial", true);
      //   localStorage.setItem("access", true);
      // }

      //* Check if licence.access key property is set in the future and there is a stripe subscription [normal access for subscribed users]
      else if (
        userData[0].licence.access &&
        accessLimitMoment.isAfter(moment()) &&
        userData[0].licence.type
      ) {
        // alert("ACCESS type: NO TRIAL + ACCESS");
        localStorage.setItem('trial', false);
        localStorage.setItem('access', true);
      }

      //* Otherwise not granting access [users cannot logging in]
      else {
        // alert("ACCESS type: NO TRIAL + NO ACCESS");
        localStorage.setItem('trial', false);
        localStorage.setItem('access', false);
      }

      //! ASSIGNING SUBSCRIPTION

      localStorage.setItem('sub', userData[0].licence.type);

      //* user without a subscription
      if (userData[0].licence.type === null) {
        //alert("SUBSCRIPTION: none");
        localStorage.setItem('sub', 'none');
      } //* Customers in test trial
      else if (
        (userData[0].licence.type === null ||
          userData[0].licence.type === '') &&
        userData[0].licence.access !== null &&
        accessLimitMoment.isAfter(moment())
      ) {
        //alert("SUBSCRIPTION: TRIAL");
        localStorage.setItem('sub', 'trial');
      } //* user with cancelled subscription
      else if (userData[0].licence.type === 'cancelled') {
        // alert("SUBSCRIPTION: cancelled");
        localStorage.setItem('sub', 'cancelled');
      }

      //* Black Admin or users with special powers like sequentia team or demos
      if (
        userData[0].username === 'admin@admin.com' ||
        userData[0].username === 'europe@europe.com' ||
        userData[0].username.split('@').pop() === 'sequentiabiotech.com'
      ) {
        //alert("SUBSCRIPTION: unlimited");
        localStorage.setItem('sub', 'unlimited');
        localStorage.setItem('access', true);
        localStorage.setItem('trial', false);
      }

      localStorage.setItem('isOldUser', false);

      //* Existing / Old users waiting for migration
      if (
        userData[0].licence.access !== null &&
        accessLimitMoment.isAfter(moment()) &&
        userData[0].licence.type === null &&
        ((userData[0].validationDate &&
          validationDateMoment.isBefore(moment('26/3/2021', 'DD/MM/YYYY'))) ||
          !userData[0].validationDate)
      ) {
        localStorage.setItem('sub', 'unlimited');
        localStorage.setItem('access', true);
        localStorage.setItem('trial', false);
        localStorage.setItem('isOldUser', true);
      }

      //! ASSIGNING ROLE

      if (userData[0].isAdmin.toString() === "3") {
        localStorage.setItem('role', 'mick_admin');
        localStorage.setItem('__theme_color', 'dark.blue');
      } else if (userData[0].isAdmin === 2) {
        localStorage.setItem('role', 'super_admin');
      } else if (userData[0].isAdmin === 1) {
        localStorage.setItem('role', 'admin');
      } else {
        localStorage.setItem('role', 'user');
      }    

      //! ASSIGNING LANGUAGE
      localStorage.setItem(
        'currentLanguage',
        userData[0].language.toLowerCase()
      );

      //localStorage.setItem("userData", JSON.stringify(userData[0]));
      //localStorage.setItem("currentLanguage",getUser[0].language.toLowerCase());
      yield put(loginUserSuccess(userData[0]));

      //* if user come from an internal URL but there is no access, at login go back to the URL
      // useful for giving URL links to logout users or for letting user bookmarks internal URLs
      if (originURL) {
        //? not using history.push method because we've to refresh the page and fetch all data before rendering
        //! not working, load
        //history.push("/app");
        window.location.replace('/app');
        //window.location.replace(originURL);
      } else {
        window.location.replace('/app');
      }
    } else {
      yield put(loginUserError(loginUser));
    }
  } catch (error) {
    yield put(loginUserError(error));
  }
}

//* SIGN UP - first user registration ad Admin and Dashboard creation // -----------------------------------------------------

const signupUserRequest = async (payload) => {
  console.log(payload);
  const {
    affiliation,
    country,
    name,
    surname,
    email,
    password,
    policyConsent,
  } = payload.user;

  const language =
    country === 'Italy' ? 'IT' : country === 'Spain' ? 'ES' : 'EN';

  //?not possible to use a stringedJSONdata because server does not accept a json but a query. Ask Andreu to change it
  const stringedJSONData = JSON.stringify({
    affiliation,
    'fiscal-information': {
      contact: {
        fiscalCountry: country,
      },
    },
    language,
    name,
    surname,
    email,
    password,
    policy: {
      consent: policyConsent,
    },
  });

  const data = {
    affiliation,
    fiscalCountry: country,
    language,
    name,
    surname,
    email,
    password,
    policyConsent,
  };

  //* Using queryString module in order to obetein a stringed query data to send via https
  // need to use "Content-Type": "application/x-www-form-urlencoded",
  var stringedQUERYData = queryString.stringify(data, {
    skipNull: true,
  });

  console.log(stringedJSONData);
  console.log(stringedQUERYData);

  return await fetch(`/mick/doctors/add/`, {
    method: 'post',
    credentials: 'same-origin',
    headers: {
      'Access-Control-Allow-Origin': 'https://35.189.226.137',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: stringedQUERYData,
  })
    .then((response) => {
      console.log(response);
      return response.text();
    })
    .then((response) => {
      console.log(response);
      return response;
    });
};

function* signupUser({ payload }) {
  console.log(payload);

  try {
    const response = yield call(signupUserRequest, payload);
    console.log(response);

    if (!response.includes('ERROR')) {
      console.log(response);

      yield put(signupUserSuccess(response));
    } else {
      console.log(response);

      yield put(signupUserError(response));
    }
  } catch (error) {
    yield put(signupUserError(error.message));
  }
}

//* CHECK user & affiliation  // -----------------------------------------------------

const getCheckUserAsync = async (username) =>
  await fetch(`/mick/doctors/${username}/affiliation `, {
    method: 'get',
    credentials: 'include', // add the cookie to the request
    headers: {
      'Content-Type': 'application/json', //because we are requesting data in JSON type
    },
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      return data;
    });

function* checkUser({ payload }) {
  console.log(payload);

  const username = payload.user;

  try {
    const response = yield call(getCheckUserAsync, username);
    console.log(response);

    if (!response.includes('ERROR')) {
      console.log(response);

      yield put(checkUserSuccess(response));
    } else {
      console.log(response);

      yield put(checkUserError('There is an unknown error'));
    }
  } catch (error) {
    yield put(checkUserError(error.message));
  }
}

//* SIGN IN - first user registration basic doctor // -----------------------------------------------------

const signinUserRequest = async (payload) => {
  console.log(payload);
  const {
    email,
    name,
    surname,
    gender,
    specialty,
    rank,
    isAdmin,
    password,
    policyConsent,
  } = payload.user;

  const browserLang = navigator.language.substring(0, 2).toUpperCase();
  const language =
    browserLang === 'ES' ||
    browserLang === 'IT' ||
    browserLang === 'EN' ||
    browserLang === 'CAT'
      ? browserLang
      : 'EN';

  const data = {
    email,
    name,
    surname,
    gender,
    language,
    specialty,
    rank,
    isAdmin, //! isAdmin: 0 not accepted by backend, ask andreu
    password,
    policyConsent,
  };

  //* Using queryString module in order to obetein a stringed query data to send via https
  // need to use "Content-Type": "application/x-www-form-urlencoded",
  var stringedQUERYData = queryString.stringify(data, {
    skipNull: true,
  });

  console.log(stringedQUERYData);

  return await fetch(`/mick/doctors/insert`, {
    method: 'post',
    credentials: 'same-origin',
    headers: {
      'Access-Control-Allow-Origin': 'https://35.189.226.137',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: stringedQUERYData,
  })
    .then((response) => {
      console.log(response);
      return response.text();
    })
    .then((response) => {
      console.log(response);
      return response;
    });
};

function* signinUser({ payload }) {
  console.log(payload);

  try {
    const response = yield call(signinUserRequest, payload);
    console.log(response);

    if (!response.includes('ERROR')) {
      console.log(response);

      yield put(signinUserSuccess(response));
    } else {
      console.log(response);

      yield put(
        signinUserError(
          'Seems that a doctor with this email address is already present in the Data Delivery Platform'
        )
      );
    }
  } catch (error) {
    yield put(signinUserError(error.message));
  }
}

//* REGISTER User // -----------------------------------------------------
// OLD API, now we have attach and insert
const registerWithEmailPasswordAsync = async (
  name,
  surname,
  email,
  password,
  language,
  affiliation,
  gender,
  policyConsent
) => {
  var data = {
    name,
    surname,
    email,
    password,
    language,
    affiliation,
    gender,
    policyConsent,
  };

  //* utilizzando il modulo queryString
  var stringedData = queryString.stringify(data, {
    arrayFormat: 'bracket',
    skipNull: true,
  });

  console.log(data);
  console.log(stringedData);

  return await fetch(`/mick/doctors/add/`, {
    method: 'post',
    credentials: 'same-origin',
    headers: {
      'Access-Control-Allow-Origin': 'https://35.189.226.137',
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: stringedData,
    //make sure to serialize your JSON body
    // body: getBody({
    //   name,
    //   surname,
    //   email,
    //   password,
    //   language,
    //   affiliation,
    //    gender,
    // }),
  }).then((authUser) => {
    //console.log(authUser); // here the error 500
    //console.log(authUser.headers);
    return authUser;
  });
};

function* registerWithEmailPassword({ payload }) {
  console.log(payload);
  const { name, surname, email, password, affiliation, gender, policyConsent } =
    payload.user;

  console.log(
    getBody({
      name,
      surname,
      email,
      password,
      affiliation,
      gender,
      policyConsent,
    })
  );

  const browserLang = navigator.language.substring(0, 2).toUpperCase();
  const language =
    browserLang === 'ES' ||
    browserLang === 'IT' ||
    browserLang === 'EN' ||
    browserLang === 'CAT'
      ? browserLang
      : 'EN';
  const { history } = payload;
  console.log(name);
  console.log(surname);
  console.log(language);
  try {
    const registerUser = yield call(
      registerWithEmailPasswordAsync,
      name,
      surname,
      email,
      password,
      language,
      affiliation,
      gender,
      policyConsent
    );
    console.log(registerUser);

    if (registerUser.status === 200) {
      console.log(registerUser.status);

      yield put(registerUserSuccess(registerUser[0]));
      history.push('./register-success');
    } else {
      console.log(registerUser.status);
      //console.log(registerUser[0].status);

      yield put(
        registerUserError(
          'A doctor with this email address is already present in the Data Delivery Platform'
        )
      );
    }
  } catch (error) {}
}

//* LOGOUT User // -----------------------------------------------------

function logout({ payload }) {
  const { history } = payload;

  localStorage.removeItem('user_id');
  localStorage.removeItem('username');
  localStorage.removeItem('role');
  localStorage.removeItem('trial');
  localStorage.removeItem('sub');
  localStorage.removeItem('currentLanguage');
  localStorage.removeItem('access');
  localStorage.removeItem('contactIdHolded');
  localStorage.removeItem('isOldUser');

  //* check if default theme color is light-blue (only super admin use dark mode)
  //? to delete if using color switcher for all users
  if (localStorage.getItem('__theme_color') === 'dark.blue') {
    localStorage.setItem('__theme_color', 'light.blue');
    setTimeout(() => {
      window.location.reload();
    }, 800);
  }
  //localStorage.removeItem("currentLanguage");
}

//* FORGOT PASSWORD User // -----------------------------------------------------
//! example of well done api call

const forgotPasswordAsync = async (email) =>
  await fetch(`/mick/doctors/${email}/resetpass `, {
    method: 'put',
    headers: {
      'Access-Control-Allow-Origin': 'https://35.189.226.137',
    },
  }).then((response) => {
    console.log(response);
    return response;
  });

const forgotPasswordAsyncText = async (email) =>
  await fetch(`/mick/doctors/${email}/resetpass `, {
    method: 'put',
    headers: {
      'Access-Control-Allow-Origin': 'https://35.189.226.137',
    },
  })
    .then((response) => {
      console.log(response);
      return response.text();
    })
    .then((response) => {
      console.log(response);
      return response;
    });

function* forgotPassword({ payload }) {
  console.log(payload);
  const { email } = payload.forgotPassword;
  try {
    //const forgotPasswordStatus = yield call(forgotPasswordAsync, email);
    const forgotPasswordText = yield call(forgotPasswordAsyncText, email);

    if (!forgotPasswordText.includes('ERROR')) {
      yield put(forgotPasswordSuccess('success'));
    } else {
      yield put(forgotPasswordError(forgotPasswordText));
    }
  } catch (error) {
    // if the legacy error is not taken, then give a local custom error
    yield put(forgotPasswordError('Server error:', error));
  }
}

//* RESET PASSWORD User // -----------------------------------------------------

const resetPasswordAsync = async (username, oldPassword, newPassword) =>
  await fetch(`/mick/doctors/resetpass `, {
    method: 'post',
    headers: {
      'Access-Control-Allow-Origin': 'https://35.189.226.137',
      'Content-Type': 'application/x-www-form-urlencoded',
      credentials: 'include', // add the cookie to the header
    },
    body: getBody({ username, oldPass: oldPassword, newPass: newPassword }),
  }).then((response) => {
    console.log(response);
    return response;
  });

const resetPasswordAsyncText = async (username, oldPassword, newPassword) =>
  await fetch(`/mick/doctors/resetpass `, {
    method: 'post',
    headers: {
      'Access-Control-Allow-Origin': 'https://35.189.226.137',
      'Content-Type': 'application/x-www-form-urlencoded',
      credentials: 'include', // add the cookie to the header
    },
    body: getBody({ username, oldPass: oldPassword, newPass: newPassword }),
  })

function* resetPassword({ payload }) {
  const { username, oldPassword, newPassword } = payload;

  try {
    const response = yield call(
      resetPasswordAsyncText,
      username,
      oldPassword,
      newPassword
    );
    if(response.ok) {
      yield put(resetPasswordSuccess('success'));
    } else throw response;

  } catch (error) {
    const errorMsg = yield error.text();
    yield put(resetPasswordError('Server error: ' + errorMsg));
  }
}

//!2. Our watcher saga
export function* watchLoginUser() {
  yield takeEvery(LOGIN_USER, loginWithEmailPassword);
}

export function* watchSignupUser() {
  yield takeEvery(SIGNUP_USER, signupUser);
}

export function* watchCheckUser() {
  yield takeEvery(CHECK_USER, checkUser);
}

export function* watchSigninUser() {
  yield takeEvery(SIGNIN_USER, signinUser);
}

export function* watchRegisterUser() {
  yield takeEvery(REGISTER_USER, registerWithEmailPassword);
}

export function* watchLogoutUser() {
  yield takeEvery(LOGOUT_USER, logout);
}

export function* watchForgotPassword() {
  yield takeEvery(FORGOT_PASSWORD, forgotPassword);
}

export function* watchResetPassword() {
  yield takeEvery(RESET_PASSWORD, resetPassword);
}

//!3. Our root saga
// single entry point to start sagas at once

export default function* rootSaga() {
  yield all([
    fork(watchLoginUser),
    fork(watchLogoutUser),
    fork(watchSignupUser),
    fork(watchCheckUser),
    fork(watchSigninUser),
    fork(watchRegisterUser),
    fork(watchForgotPassword),
    fork(watchResetPassword),
  ]);
}
